(() => {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    const operationButton = document.getElementById("js-operation-button");
    if (operationButton) {
      operationButton.addEventListener("click", function () {
        const parent = this.closest("#js-operation-parent");
        if (parent) {
          parent.classList.toggle("-active");
        }
      });
    }
  });
})();
